import React from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { useState, useEffect, useRef } from 'react';
import { db } from '../firebase/config';
import { Link, useNavigate } from 'react-router-dom';
import { FIRESTORE_CONSTANTS } from '../constants';

function Navigation({ closeNav, openMenus, setOpenMenus, toggleMenu }) {
  const [menuStructure, setMenuStructure] = useState([]);
  const [loading, setLoading] = useState(true);const [searchTerm, setSearchTerm] = useState(""); // 검색어 상태
  const linkRefs = useRef({});
  const navigate = useNavigate(); // 이동을 위한 hook

  useEffect(() => {
    async function fetchMenuStructure() {
      try {
        const collections = await getDocs(collection(db, FIRESTORE_CONSTANTS.ROOT_COLLECTION));
        const menuPromises = collections.docs.map(async (doc) => {
          const subcollections = await getDocs(
            collection(db, `${FIRESTORE_CONSTANTS.ROOT_COLLECTION}/${doc.id}/${doc.id}`)
          );

          return {
            id: doc.id,
            title: doc.data()[FIRESTORE_CONSTANTS.DOCUMENT_FIELDS.TITLE] || doc.id,
            path: `/${doc.id}`,
            order: doc.data()[FIRESTORE_CONSTANTS.DOCUMENT_FIELDS.ORDER] || FIRESTORE_CONSTANTS.DEFAULT_ORDER,
            subMenus: subcollections.docs.map(subdoc => ({
              id: subdoc.id,
              title: subdoc.data()[FIRESTORE_CONSTANTS.DOCUMENT_FIELDS.TITLE] || subdoc.id,
              path: `/${doc.id}/${subdoc.id}`,
              order: subdoc.data()[FIRESTORE_CONSTANTS.DOCUMENT_FIELDS.ORDER] || FIRESTORE_CONSTANTS.DEFAULT_ORDER
            })).sort((a, b) => a.order - b.order)
          };
        });

        const menus = await Promise.all(menuPromises);
        const sortedMenus = menus.sort((a, b) => a.order - b.order);
        setMenuStructure(sortedMenus);
      } catch (error) {
        console.error("Error fetching menu structure:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchMenuStructure();
  }, []);

  const setLinkRef = (menuId, index) => (el) => {
    if (!linkRefs.current[menuId]) {
      linkRefs.current[menuId] = {};
    }
    linkRefs.current[menuId][index] = el;
  };

  const handleMenuToggle = (menuId, index) => {
    toggleMenu(menuId);
    if (!openMenus[menuId] && linkRefs.current[menuId]?.[index]) {
      linkRefs.current[menuId][index].focus();
    } else {
      document.activeElement.blur();
    }
  };

  const isLastMenu = (index) => index === menuStructure.length - 1;
  
  // 검색 제출 핸들러
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    
    // 1. 공백만 있거나 아예 비어있는 경우
    if (!searchTerm.trim()) {
      alert("검색어를 입력해주세요.");
      return;
    }

    // 2. 한 글자만 입력한 경우 (유안님이 요청하신 2글자 제한)
    if (searchTerm.trim().length < 2) {
      alert("검색어가 너무 짧습니다. 2글자 이상 입력해주세요.");
      return;
    }

    // 모든 조건을 통과하면 검색 페이지로 이동
    navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
    setSearchTerm(""); // 입력창 비우기
    closeNav(); // 네비게이션 닫기
  };

  return (
    <nav id='nav'>
      <div className='nav_area'>
        <ul className='gnb'>
          <li className='searchbox'>
            <form onSubmit={handleSearchSubmit}>
              <input  type="text" 
                      placeholder='검색어 입력' 
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)} />
              <button type='submit'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="search_btn"><circle cx="10" cy="10" r="7" class="primary"/><path class="secondary" d="M16.32 14.9l1.1 1.1c.4-.02.83.13 1.14.44l3 3a1.5 1.5 0 0 1-2.12 2.12l-3-3a1.5 1.5 0 0 1-.44-1.14l-1.1-1.1a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"/></svg>
              </button>
            </form>
          </li>
          {
            loading ? <li className='prep'>로딩 중...</li>
                    : menuStructure.map((menu, i) => (
                      <li className='depth01' key={i}>
                        <Link to={menu.path} 
                              onClick={closeNav}
                              ref={setLinkRef(menu.id, i)}>
                                {menu.title}
                        </Link>
                        {
                          // 마지막 요소가 아니고 subMenus가 있을 때만 토글 버튼 표시
                          !isLastMenu(i) && menu.subMenus.length > 0 && (
                            !openMenus[menu.id] ?
                            <span className='down' 
                                  onClick={() => handleMenuToggle(menu.id, i)}
                                  role='button'
                                  aria-label='하위 메뉴 열기'>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-8 mr-4 icon-cheveron-down">
                                <path className="secondary" fillRule="evenodd" d="M15.3 10.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"/>
                              </svg>
                            </span>
                            :
                            <span className='up' 
                                  onClick={() => handleMenuToggle(menu.id, i)}
                                  role='button'
                                  aria-label='하위 메뉴 닫기'>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-8 mr-4 icon-cheveron-up">
                                <path className="secondary" fillRule="evenodd" d="M8.7 13.7a1 1 0 1 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1-1.4 1.4L12 10.42l-3.3 3.3z"/>
                              </svg>
                            </span>
                          )
                        }
                        {
                          // 마지막 요소가 아닐 때만 submenu 표시
                          !isLastMenu(i) && (
                            <ul className={`submenu ${openMenus[menu.id] ? 'open' : ''}`}>
                              {menu.subMenus.map((sub, k) => (
                                <li key={k}
                                    inert={openMenus[menu.id] ? false : true}>
                                  <Link key={sub.id} 
                                        to={sub.path} 
                                        onClick={() => { closeNav(); }}
                                        aria-disabled={openMenus[menu.id] ? false : true}
                                        tabIndex={openMenus[menu.id] ? 0 : -1}>
                                    {sub.title}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          )
                        }
                      </li>
                    ))
          }
        </ul>
      </div>
    </nav>
  );
}

export default React.memo(Navigation);
